import React from 'react';

import { Flash } from 'AWS-UI-Components-React';

export class Loading extends React.Component {
  render() {
    return <Flash loading={true} content="Authenticating..." />;
  }
}



// WEBPACK FOOTER //
// ./src/components/loading.jsx